module.exports = __webpack_public_path__ + "img/logoes.40514597.png";